import {
  faExclamationCircle,
  faFile,
  faFilePdf,
  faFileWord,
  faSpinnerThird,
} from '@fortawesome/pro-regular-svg-icons'

import { AttachmentWithUploadStatus } from 'types/AttachmentWithUploadStatus'

type Input = {
  attachmentStatus?: AttachmentWithUploadStatus['status']
  contentType: AttachmentWithUploadStatus['contentType']
}

export const getFileIcon = ({ attachmentStatus, contentType }: Input) => {
  if (attachmentStatus === 'error') return { icon: faExclamationCircle }
  if (attachmentStatus === 'deleting' || attachmentStatus === 'uploading') return { icon: faSpinnerThird }

  switch (contentType) {
    case 'application/pdf':
      return { color: '#DC143C', icon: faFilePdf }
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return { color: '#244CA9', icon: faFileWord }
    default:
      return { color: '#2f2f2b', icon: faFile }
  }
}
